import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {
  APIResponse,
  AppSettingsSliceInitailState,
  AppSpecialization,
  AppSpecialistListResponse,
  AppCountryList,
  GetAdminRolesSuccessResponse,
  GetSpecialistFilterOptionsSuccessResponse,
} from '@/interface';

const initialState: AppSettingsSliceInitailState = {
  appSettingsFailure: false,
  appSettingsSuccess: false,
  isLoading: false,
  specialization: [],
  specialistList: [],
  countries: [],
  adminRoles: [],
filterManagement: {
    experienceFilters: [],
    ratingFilters: [],
    chargesFilters: [],
  },

  // global state for dashboard search term
  dashboardSearchTerm: '',
};

const appSettingSlice = createSlice({
  name: 'appSettings',
  initialState,
  reducers: {
    getSpecializationRequest(state) {
      state.isLoading = true;
      state.appSettingsFailure = false;
      state.appSettingsSuccess = false;
    },
    getSpecializationFailure(state, action: PayloadAction<APIResponse>) {
      state.isLoading = false;
      state.appSettingsFailure = action.payload.status_code;
    },
    getSpecializationSuccess(state, action: PayloadAction<AppSpecialization>) {
      state.isLoading = false;
      state.appSettingsSuccess = action.payload.status_code;
      state.specialization = action.payload.data;
    },

    /**
     * get specialist list
     */

    getLandingSpecialistListRequest(state) {
      state.isLoading = true;
      state.appSettingsFailure = false;
      state.appSettingsSuccess = false;
    },
    getLandingSpecialistListFailure(state, action: PayloadAction<APIResponse>) {
      state.isLoading = false;
      state.appSettingsFailure = action.payload.status_code;
    },
    getLandingSpecialistListSuccess(state, action: PayloadAction<AppSpecialistListResponse>) {
      state.isLoading = false;
      state.appSettingsSuccess = action.payload.status_code;
      state.specialistList = action.payload.data
    },

    /**
     * get country list
     */

    getCountryListRequest(state) {
      state.isLoading = true;
      state.appSettingsFailure = false;
      state.appSettingsSuccess = false;
    },
    getCountryListFailure(state, action: PayloadAction<APIResponse>) {
      state.isLoading = false;
      state.appSettingsFailure = action.payload.status_code;
    },
    getCountryListSuccess(state, action: PayloadAction<AppCountryList>) {
      state.isLoading = false;
      state.appSettingsSuccess = action.payload.status_code;
      state.countries = action.payload.data;
    },

    /**
     * get admin roles
     */
    getAdminRolesRequest(state) {
      state.isLoading = true;
      state.appSettingsFailure = false;
      state.appSettingsSuccess = false;
    },
    getAdminRolesFailure(state, action: PayloadAction<APIResponse>) {
      state.isLoading = false;
      state.appSettingsFailure = action.payload.status_code;
    },
    getAdminRolesSuccess(state, action: PayloadAction<GetAdminRolesSuccessResponse>) {
      state.isLoading = false;
      state.appSettingsSuccess = action.payload.status_code;
      state.adminRoles = action.payload.data;
    },

    /**
     * get filter options
     */
    getSpecialistFilterOptionsRequest(state) {
      state.isLoading = true;
      state.appSettingsFailure = false;
      state.appSettingsSuccess = false;
    },
    getSpecialistFilterOptionsFailure(state, action: PayloadAction<APIResponse>) {
      state.isLoading = false;
      state.appSettingsFailure = action.payload.status_code;
    },
    getSpecialistFilterOptionsSuccess(state, action: PayloadAction<GetSpecialistFilterOptionsSuccessResponse>) {
      state.isLoading = false;
      state.appSettingsSuccess = action.payload.status_code;
      state.filterManagement = {
        experienceFilters: action.payload.data.experience,
        ratingFilters: action.payload.data.rating,
        chargesFilters: action.payload.data.charge,
      };
    },

    /**
     * utilty
     */
    resetAppSettingsMessage(state) {
      state.appSettingsFailure = false;
      state.appSettingsSuccess = false;
    },
    cancelAppSettingsRequest(state){
      state.isLoading = false;
    },
    setDashboardSearchTerm: (state, action: PayloadAction<string>) => {
      state.dashboardSearchTerm = action.payload;
    },
  },
});

export const {
  // specialization list api
  getSpecializationFailure,
  getSpecializationRequest,
  getSpecializationSuccess,
  
  // landing specialist list api
  getLandingSpecialistListFailure,
  getLandingSpecialistListRequest,
  getLandingSpecialistListSuccess,

  // country list api
  getCountryListFailure,
  getCountryListRequest,
  getCountryListSuccess,

  // admin roles api
  getAdminRolesFailure,
  getAdminRolesRequest,
  getAdminRolesSuccess,
  
  // get filter options
  getSpecialistFilterOptionsFailure,
  getSpecialistFilterOptionsRequest,
  getSpecialistFilterOptionsSuccess,

  // cancel and reset reducers
  resetAppSettingsMessage,
  cancelAppSettingsRequest,

  // utility reducers
  setDashboardSearchTerm,
} = appSettingSlice.actions;
export default appSettingSlice.reducer;